<template>
  <pr-box :title="titleBox">

    <div slot="buttons-header">
      <v-btn icon :to="{ name: 'load-conf-form', params: { id: 'new' }}" v-if="!widget">
        <v-icon color="white">add</v-icon>
      </v-btn>
    </div>

    <v-layout row wrap>
      <v-flex xs12 md6>
        <v-autocomplete
          :items="clients"
          :filter="filterClients"
          item-text="name"
          item-value="id"
          hint="Selecionar cliente"
          v-model="clientId"
          required
          persistent-hint
          clearable
          :disabled="(clients.length === 0)"
          no-data-text="Nenhuma registro encontrado"
          :error-messages="validationErrors.clientId"></v-autocomplete>
      </v-flex>
      <v-flex xs12 md6>
        <v-autocomplete
          :items="projects"
          :filter="filterProjects"
          item-text="name"
          item-value="id"
          hint="Selecionar projeto"
          v-model="projectId"
          required
          persistent-hint
          clearable
          :disabled="(projects.length === 0)"
          no-data-text="Nenhuma registro encontrado"
          :error-messages="validationErrors.projectId"></v-autocomplete>
      </v-flex>
      <v-flex xs12 md12 text-md-center>
        <v-btn flat color="primary" @click="search()">
          <v-icon>search</v-icon>
          Pesquisar
        </v-btn>
      </v-flex>
    </v-layout>

    <div>

      <v-data-table
        :headers="headers"
        :items="resources"
        :total-items="totalResources"
        :pagination.sync="orderSync"
        :no-data-text="noDataAvailable"
        :hide-actions="true"
        :loading="searchLoading"
        class="elevation-0">

        <template slot="items" slot-scope="props">

          <td>
            {{ props.item.project.name }}
          </td>
          <td>
            {{ props.item.ds_load_conf }}
          </td>
          <td>
            {{ props.item.ds_charge_periodicity }}
          </td>
          <td>
            {{ props.item.qt_charge_periodicity }}
          </td>
          <td>
            {{ props.item.load_notification_conf.load_notification_type.description }}
          </td>
          <td>
            {{ props.item.fl_active === '1' ? 'SIM' : 'NÃO' }}
          </td>
          <td class="text-xs-center">

            <v-btn color="primary" flat icon @click="goToForm(props.item.id)">
              <v-icon>mode_edit</v-icon>
            </v-btn>

            <v-btn flat icon color="error" @click="destroy(props.item.id, props.item.project.name)">
              <v-icon>delete</v-icon>
            </v-btn>

          </td>
        </template>
      </v-data-table>
      <pr-pagination :paginator="paginator"></pr-pagination>
    </div>
  </pr-box>
</template>

<script>
import CrudMixin from '@/components/mixins/CrudMixin';
import LoadConfService from '@/features/load-conf/LoadConfService';
import ProjectService from '@/features/project/ProjectService';
import ClientService from '@/features/client/ClientService';

export default {
  name: 'load-conf-list',
  mixins: [CrudMixin],
  props: {
    widget: {
      default: false,
    },
  },
  data() {
    return {
      projects: [],
      projectId: null,
      clients: [],
      clientId: null,
      clientService: new ClientService(),
      projectService: new ProjectService(),
      headers: [
        {
          text: this.$t('attributes.load_conf.project'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.load_conf.description'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.load_conf.periodicity'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.load_conf.qtd_periodicity'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.load_conf.types'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.load_conf.active'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('views.fields.actions'),
          sortable: false,
          align: 'rigth',
        },
      ],
    };
  },
  watch: {
    clientId() {
      this.projectId = null;
      this.fetchProjects();
    },
  },
  beforeMount() {
    this.fetchProjects();
    this.fetchClients();
  },
  methods: {
    initCrud() {
      this.serviceType = LoadConfService;
      this.routerName = 'load-conf';
    },
    applyFilters(filter) {
      const params = {
        project_id: this.projectId,
        client_id: this.clientId,
      };
      return Object.assign(filter, params);
    },
    filterProjects(item, queryText) {
      const textOne = item.name.toLowerCase();
      const textTwo = item.responsible_name.toLowerCase();
      const searchText = queryText.toLowerCase();

      return textOne.indexOf(searchText) > -1 ||
        textTwo.indexOf(searchText) > -1;
    },
    filterClients(item, queryText) {
      const textOne = item.name.toLowerCase();
      const searchText = queryText.toLowerCase();

      return textOne.indexOf(searchText) > -1;
    },
    async fetchProjects() {
      const params = {};
      if (this.clientId) {
        params.client_id = this.clientId;
      }
      this.projects = await this.projectService.query(params);
      if (this.projects.length === 1) {
        this.projectId = this.projects[0].id;
      }
    },
    async fetchClients() {
      this.clients = await this.clientService.query();
      if (this.clients.length === 1) {
        this.clientId = this.clients[0].id;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/features/load-conf/LoadConfList.vue